import type { FeatureCooldownType } from './types';
import { getMsUntil } from '../../../utils/time-utils';

export function getTimeUntilFeatureAvailable(
  type: FeatureCooldownType,
  featureCooldowns: Partial<Record<FeatureCooldownType, number>>,
): number {
  return getMsUntil(featureCooldowns[type] ?? 0);
}
